import React from 'react';
import { useTranslation } from 'react-i18next';
import { InputText } from '../ui';

interface Props {
  email: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
}

const VerificationCode: React.FC<Props> = ({ email, onChange }) => {
  const { t, i18n } = useTranslation();

  return (
    <div>
      <p>
        {t('An email with a verification code was sent to')} <span className="font-bold">{email}.</span>
      </p>
      <p className="mb-3">{t('Please check your inbox and enter the code below to verify your email address.')}</p>
      <InputText placeholder={t('Enter code')} required onChange={onChange} className="inputWrapper w-full" />
    </div>
  );
};

export default VerificationCode;
